<template>
  <div class="search-view-newssearch">
    <b-card id="card">
      <div>
        <button class="btn" @click="dialog = true">
          {{ results.title }}
        </button>
      </div>
    </b-card>
    <b-modal v-model="dialog" hide-header hide-footer centered size="lg">
      <newsletter-modal :news="results" @close="dialog = false" />
    </b-modal>
  </div>
</template>
<script>
import NewsletterModal from "../home/NewsletterModal.vue";
export default {
  props: {
    results: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  components: { NewsletterModal }
};
</script>
<style lang="scss" scoped>
.search-view-newssearch {
  background: rgba(0, 0, 0, 0.3);
  padding-bottom: 10%;
  border-radius: 20px;
  #card {
    background: transparent;
    border: none;
  }

  .btn {
    border: none;
    font-size: 22px;
    color: white;
  }
}
</style>
